import { Mic, Theater, Lightbulb, Users, Flame, Music, Wand2, Copy, VenetianMask } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

const comedyForms = [
  { icon: Mic, title: "Stand-up", description: "Klasyczna forma komedii, gdzie komik występuje sam na scenie, dzieląc się swoimi obserwacjami i historiami." },
  { icon: Theater, title: "Kabaret", description: "Skecze i scenki komediowe w wykonaniu grupy artystów, często z wykorzystaniem rekwizytów i kostiumów." },
  { icon: Lightbulb, title: "Improwizacja", description: "Spontaniczne tworzenie scenek i historii na podstawie sugestii publiczności." },
  { icon: Users, title: "Komedia improwizowana", description: "Dłuższe formy teatralne tworzone na żywo, bez scenariusza, z aktywnym udziałem widowni." },
  { icon: Flame, title: "Roast", description: "Humorystyczne przedstawienie, gdzie zaproszeni goście żartobliwie krytykują głównego bohatera wydarzenia." },
  { icon: Copy, title: "Parodia", description: "Komiczne naśladowanie znanych osób, utworów lub zjawisk w zabawny i przejaskrawiony sposób." },
  { icon: Music, title: "Karaoke komediowe", description: "Połączenie śpiewu z elementami komedii, gdzie uczestnicy wykonują zabawne wersje znanych utworów." },
  { icon: Wand2, title: "Magik komediowy", description: "Występy łączące sztukę iluzji z elementami komedii i humoru." },
  { icon: VenetianMask, title: "Pantomima komediowa", description: "Komediowe przedstawienie bez użycia słów, oparte na gestach i mimice." },
];

export const FormsOfComedy = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent font-semibold text-sm uppercase tracking-widest"><span className="text-accent font-semibold text-sm uppercase tracking-widest">Co oferujemy?</span></span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-foreground">
              Formy komedii
            </h2>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-3 gap-6">
          {comedyForms.map((form, i) => {
            const Icon = form.icon;
            return (
              <ScrollReveal key={form.title} delay={i * 80}>
                <div className="group p-6 rounded-2xl bg-secondary/50 border border-border/50 card-hover hover:border-accent/30">
                  <div className="w-14 h-14 rounded-xl bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
                    <Icon className="w-7 h-7 text-accent" />
                  </div>
                  <h3 className="text-xl font-montserrat font-bold mb-2 text-foreground group-hover:text-accent transition-colors">
                    {form.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{form.description}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
